module.exports = __webpack_public_path__ + "img/fapiao2.46708894.png";